<template>
  <!-- 选择用户 -->
  <el-dialog v-el-drag-dialog append-to-body  class="user-choose" :title="userChooseTitle" :visible.sync="visible" width="600px" @close="userChooseClose">
    <el-row :gutter="20" type="flex" class="dialog-row" justify="space-around">
      <el-col :span="12">
        <el-card class="box-card" shadow="hover" body-style="padding:16px 5px">
          <div slot="header">
            <el-button type="text" @click="userChooseClear" style="font-size:14px;padding:0">{{$t('mail.dept')}}</el-button>
          </div> 
          <el-scrollbar style="height:calc(100%);">
            <el-tree 
              style="height: 328px;"
              ref="tree"
              highlight-current
              default-expand-all
              :data="treeData" 
              :props="defaultProps"
              node-key="id"
              :expand-on-click-node="false"
              @node-click="userChooseTreeClick">
            </el-tree>
          </el-scrollbar>
        </el-card>
      </el-col>
        <el-col :span="12">          
          <el-card class="box-card" shadow="hover" body-style="height: 360px;">
            <div slot="header" style="padding:0;height:21px">
              <el-checkbox v-if="chooseType==='checkBox'" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"><span style="padding-left:10px">{{ dataListTitle }}</span> </el-checkbox>
              <span v-else>{{ dataListTitle }}</span> 
              <slide-search-bar :style="chooseType==='checkBox'?'width:calc(100% - 60px);':'width:calc(100% - 30px);'">
                <search-bar 
                  slot="searchBar"
                  v-model="queryList.filter"
                  @handleClear="userChooseClear"
                  @handelSearch="userChooseSearch"
                  @handelDelete="userChooseDeleteSearch"
                  :loading="userChooseLoading">
                </search-bar>
              </slide-search-bar>
            </div> 
            <div style="height:calc(100% - 10px);overflow:hidden">
              <el-scrollbar style="height:calc(100% + 37px);"
                v-loading="userChooseLoading">
                <div v-if="chooseType==='checkBox'">
                  <el-checkbox-group 
                    v-if="listData.length>0"
                    v-model="userChooseJson.checkBox">
                      <div :span="12" v-for="(item,key) in listData" :key="key" style="margin-bottom:10px;">
                        <el-checkbox :label="item.id" :value="item.id">
                          <span style="padding-left:10px">
                            {{item.name}}
                          </span>
                        </el-checkbox>
                      </div>
                  </el-checkbox-group> 
                </div>
                <div v-if="chooseType==='radioBox'">
                  <el-radio-group v-model="userChooseJson.radioBox">
                    <div :span="12" v-for="(item,key) in listData" :key="key" style="margin-bottom:15px;">
                      <el-radio :label="item" :value="item">{{item.name}}</el-radio>
                    </div>
                  </el-radio-group>
                </div>
              </el-scrollbar>
            </div>
            <el-pagination
              style="text-align:center;margin-top:3px"
              @current-change="userChooseCurrentChange"
              :current-page="queryList.PageIndex"
              small
              layout="prev, pager, next"
              :total="userChooseTotal">
            </el-pagination>
          </el-card>
        </el-col>
    </el-row>
  
    <div slot="footer" class="dialog-footer" style="text-align:center;">
      <el-button :loading="editLoading" v-waves type="primary" @click="userChooseSave" icon="el-icon-check" 
        :disabled="userChooseJson.checkBox.length === 0 &&  userChooseJson.radioBox==='' ">{{$t('buttons.determine')}}</el-button>
      <el-button v-waves @click="userChooseClose" icon="el-icon-close">{{$t('buttons.cancel')}}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import SlideSearchBar from '@/components/SlideSearchBar/index.vue'
import SearchBar from '@/components/SearchBar/index.vue'
import { getDepartments, getUsers, getUserInfo } from '@/api/OrganizationUser'
export default {
  name: 'userChoose',
  components: {
    SearchBar,
    SlideSearchBar
  },
  props: {
    showName: {
      type: Boolean,
      default: true
    },
    chooseType: String,
    dataListTitle: {
      type: String,
      default: '用户'
    },
    userChooseTitle: {
      type: String,
      default: '选择用户'
    },
    userChooseVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get: function() {
        return this.userChooseVisible
      },
      set: function() {
        return this.userChooseVisible
      }
    },
    isIndeterminate() {
      const a = new Set(this.userChooseJson.checkBox)
      const b = new Set(this.listData.map(l => l.id))
      const intersectionSet = new Set([...a].filter(x => b.has(x)))
      const arr = Array.from(intersectionSet)
      return arr.length > 0 && arr.length < this.listData.length
    },
    checkAll: {
      get: function() {
        const a = new Set(this.userChooseJson.checkBox)
        const b = new Set(this.listData.map(l => l.id))
        const intersectionSet = new Set([...a].filter(x => b.has(x)))
        const arr = Array.from(intersectionSet)
        return arr.length === this.listData.length
      },
      set: function(newValue) {
        return newValue
      }
    }
  },
  data() {
    return {
      userChooseLoading: false,
      listData: [],
      treeData: [],
      editLoading: false,
      userChooseTotal: null,
      userChooseJson: {
        checkBox: [],
        radioBox: ''
      },
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      queryList: {
        deptId: undefined,
        pageIndex: 1,
        pageSize: 10,
        sort: undefined,
        filter: ''
      }
    }
  },
  created: function() {
    this.$on('resetDialogChoose', function(list) {
      this.userChooseJson = {
        checkBox: list || [],
        radioBox: ''
      }
      this.fetchTree()
      this.queryList.deptId = 0
      this.fetchList()
    })
  },
  methods: {
    // 控制全选状态
    handleCheckAllChange(val) {
      const idArr = this.listData.map(l => l.id)
      if (val) {
        this.userChooseJson.checkBox = Array.from(new Set([...this.userChooseJson.checkBox, ...idArr]))
      } else {
        idArr.forEach(d => {
          this.userChooseJson.checkBox.splice(this.userChooseJson.checkBox.indexOf(d), 1)
        })
      }
    },
    userChooseClear() {
      this.queryList.deptId = 0
      this.queryList.pageIndex = 1
      this.fetchList()
    },
    userChooseSearch() {
      this.queryList.deptId = 0
      this.queryList.pageIndex = 1
      this.fetchList()
    },
    userChooseDeleteSearch() {
      this.queryList.pageIndex = 1
      this.fetchList()
    },
    userChooseCurrentChange(val) {
      this.queryList.pageIndex = val
      this.fetchList()
    },
    userChooseTreeClick(data) {
      this.queryList.pageIndex = 1
      this.queryList.deptId = data.id
      this.fetchList()
    },
    fetchTree() {
      getDepartments().then(response => {
        this.treeData = response.data.children
      })
    },
    fetchList() {
      this.userChooseLoading = true
      getUsers(this.queryList).then(response => {
        this.listData = response.data.data
        this.userChooseTotal = response.data.total
        this.userChooseLoading = false
      })
    },
    userChooseSave() {
      if (this.chooseType === 'checkBox') {
        this.editLoading = true
        const saveData = []
        let length = this.userChooseJson.checkBox.length
        if (this.showName) {
          this.userChooseJson.checkBox.forEach(v => {
            getUserInfo(v).then(response => {
              var json = {
                id: null,
                name: null
              }
              json.id = response.data.id
              json.name = response.data.name
              saveData.push(json)
              length--
              if (length === 0) {
                this.editLoading = false
                this.$emit('userChooseSave', saveData)
              }
            })
              .catch(() => {
                this.editLoading = false
                this.$emit('userChooseSave', saveData)
              })
          })
        } else {
          this.$emit('userChooseSave', this.userChooseJson.checkBox)
          this.editLoading = false
        }
      } else {
        this.$emit('userChooseSave', this.userChooseJson.radioBox)
      }
    },
    userChooseClose() {
      this.$emit('userChooseClose')
    }
  }

}
</script>
<style lang="scss">
.user-choose{
  .el-card__header .slideSearchBarBox {
    position: absolute;
    right: 15px;
    height: 32px;
    top: 50%;
    margin-top: -16px;
    width: calc(100% - 35px);
    text-align: right;
  }
  .el-card__header {
    padding: 10px 20px !important;
    position: relative;
  }
}
  
</style>

